import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />
        <footer>
          This project was coded by{" "}
          <a
            href="https://www.shecodes.io/graduates/179915-vivialyn-joynson"
            target="_blank"
            rel="noreferrer"
          >
            Viv
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/vivialyn14/shecodes-bootstrap-react-week5"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
